import * as React from 'react';
import ReactTable from 'react-table';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

class State {
    data: any;
    options: Array<string>;
}

interface Props {

}

export default class ManagementSystemPanel  extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            data: [],
            options: [
                'sysFqdnPriIpAddr', 'sysFqdnSecIpAddr', 'sysIvmsSysAccess', 'sysIvmsUploadIpAddr',
                'sysIvmsUploadPort'
            ]
        });
    }

    render() {
        const columns = [
            {
                Header: 'Name',
                accessor: 'str',
                headerStyle: { textAlign: 'left' },
                width: 500
            },
            {
                Header: 'Value',
                accessor: 'value',
                headerStyle: { textAlign: 'left' },
                Cell: (props: any) => this.renderer(props)
            }
        ];
        return (
            <ReactTable
                className=" -striped -highlight  -padded"
                onFetchData={() => this.fetchData()}
                data={(this.state && this.state.data) ? this.state.data : []}
                columns={columns}
                defaultPageSize={5}
                showPagination={false}
            />
        );
    }

    renderer(props: any) {
        if (props.value === 'direct') {
            return 'Direct Access';
        } else if (props.value === 'firewall') {
            return 'Behind Firewall';
        }
        return props.value;
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/sysmgmt';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: this.state.options
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    let dataArr = [];
                    responseObject[0].str = 'Primary iVMS ASM IP Address'; responseObject[1].str = 'Secondary iVMS ASM IP Address';
                    responseObject[2].str = 'System Access to iVMS';  responseObject[3].str = 'Upload Server IP Address';
                    responseObject[4].str = 'Upload Server Port for Management';

                    // tslint:disable-next-line:forin
                    for (let i in responseObject) {
                        dataArr.push(responseObject[i]);
                    }
                    _this.setState({
                        data: dataArr
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/systemInfo/managementSystem.tsx